module.exports = __webpack_public_path__ + "static/media/1_2song.c03cc5ed.png";